import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n/I18nContext";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustCredibility from "@/components/site/TrustCredibility";
import Services from "@/components/site/Services";
import Portfolio from "@/components/site/Portfolio";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Process from "@/components/site/Process";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import Insights from "@/components/site/Insights";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";

function App() {
  return (
    <I18nProvider>
      <div className="App min-h-screen bg-white text-slate-700 antialiased" data-testid="app-root">
        <Navbar />
        <main>
          <Hero />
          <TrustCredibility />
          <Services />
          <Portfolio />
          <WhyChooseUs />
          <Process />
          <Pricing />
          <Testimonials />
          <Insights />
          <FAQ />
          <Contact />
        </main>
        <Footer />
        <WhatsAppFloat />
        <Toaster position="top-right" richColors closeButton />
      </div>
    </I18nProvider>
  );
}

export default App;
